/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import { IAdminDailyMetricData } from '@datatype/admin/api-type';
import TextBlock from '@component/common/block/text-block';

interface IProps {
  daily: IAdminDailyMetricData;
  isSelected: boolean;
  handleClick: () => void;
}

const Wrapper = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid ${(p) => (p.$selected ? color.BROWN_1 : color.GRAY_3)};
  background-color: ${(p) => (p.$selected ? color.BROWN_4 : color.WHITE_1)};
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    border-color: ${color.BROWN_1};
  }
`;

const DateBox = styled.div`
  min-width: 110px;
`;

const StatGroup = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;
  align-items: center;
`;

const formatStudyTime = (ms: number): string => {
  if (!ms || ms <= 0) return '0분';
  const totalMinutes = Math.floor(ms / 1000 / 60);
  if (totalMinutes < 60) return `${totalMinutes}분`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}시간 ${minutes}분`;
};

const DailyItem: React.FC<IProps> = ({ daily, isSelected, handleClick }) => {
  return (
    <Wrapper $selected={isSelected} onClick={handleClick}>
      <DateBox>
        <TextBlock
          text={daily.date}
          design={{ text: { size: 'medium', color: color.BLACK_2, bold: true } }}
        />
      </DateBox>
      <StatGroup>
        <TextBlock
          text={`가입 ${daily.signupCount}명`}
          design={{ text: { size: 'small', color: color.BLACK_2 } }}
        />
        <TextBlock
          text={`전체 ${daily.activeStudentCount}명`}
          design={{ text: { size: 'small', color: color.BLACK_2 } }}
        />
        <TextBlock
          text={`재방문 ${daily.returningStudentCount ?? 0}명`}
          design={{ text: { size: 'small', color: color.BLACK_2 } }}
        />
        <TextBlock
          text={`학습 ${daily.studiedStudentCount}명`}
          design={{ text: { size: 'small', color: color.BLACK_2 } }}
        />
        <TextBlock
          text={`영어 ${formatStudyTime(daily.englishStudyTime)}`}
          design={{ text: { size: 'small', color: color.BLACK_2 } }}
        />
        <TextBlock
          text={`일본어 ${formatStudyTime(daily.japaneseStudyTime)}`}
          design={{ text: { size: 'small', color: color.BLACK_2 } }}
        />
      </StatGroup>
    </Wrapper>
  );
};

export default DailyItem;
